import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit {
  public isMilestone: boolean = false;
  constructor() { }

  ngOnInit() {

  }

  public onSelectionChanged(event: any) {
    this.isMilestone = event.addedItems && (event.addedItems[0].title as string).toLowerCase() === "construction milestones";
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/schedule/schedule.component.ts